export default {
  nav: {
    coreLogic: 'Основная логика',
    profitMechanism: 'Механизм прибыли',
    profitFlywheel: 'Маховик прибыли',
    sysArch: 'Архитектура системы',
    tradingExample: 'Примеры торговли',
    cta: 'Начать',
    language: 'Язык',
  },
  hero: {
    badge: 'Интеллектуальный движок Poly Ai Claw',
    title1: 'От прогноза к',
    title2: 'Вероятностному арбитражу',
    desc: 'Polywin превращает рынки предсказаний в системный арбитражный движок на базе Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'Запустить движок Poly Ai Claw',
    ctaSecondary: 'Смотреть демо',
    statsEvents: 'Отслеживаемых событий',
    statsSuccessRate: 'Успешность исполнения',
    statsExecTime: 'Время исполнения',
    cardTitle: 'Анализ отклонения вероятностей',
    cardBadge: 'Зона EV-преимущества',
    cardMarketProb: 'Рыночная вероятность',
    cardAiProb: 'ИИ-вероятность',
    cardMarketImplied: 'Подразумеваемая вероятность рынка',
    cardAiTrue: 'Истинная вероятность ИИ',
    cardProbDiff: 'Вероятностное преимущество',
  },
  coreLogic: {
    badge: 'Система принятия решений PolyAi-Claw',
    title1: 'От агрегации данных к сложным доходам —',
    title2: 'Полностью автоматический цикл',
    desc: 'Мультиисточниковые данные → ИИ-моделирование → Отклонение вероятностей → Авто-исполнение → Сложные доходы',
    step0_title: 'Уровень данных',
    step0_sub: 'Мультиисточниковая агрегация',
    step0_i0: 'Политические события',
    step0_i1: 'Макроэкономика',
    step0_i2: 'Настроения в соцсетях',
    step0_i3: 'Данные стакана заявок',
    step1_title: 'ИИ-моделирование',
    step1_sub: 'Байесовское обновление вероятностей',
    step1_i0: 'Входные данные реального времени',
    step1_i1: 'Движок ИИ-моделирования',
    step1_i2: 'Расчёт вероятностей',
    step1_i3: 'Оптимизация модели',
    step2_title: 'Обнаружение отклонений',
    step2_sub: 'Идентификация отклонения вероятностей',
    step2_i0: 'Подразумеваемая вероятность рынка',
    step2_i1: 'Истинная вероятность ИИ',
    step2_i2: 'Обнаружение EV-преимущества',
    step2_i3: 'Сигнал позиции',
    step3_title: 'Исполнение на блокчейне',
    step3_sub: 'Автоторговля на Polygon',
    step3_i0: 'Контроль рисков',
    step3_i1: 'Распределение капитала',
    step3_i2: 'Расчёт в USDC',
    step3_i3: 'Смарт-контракт',
    step4_title: 'Сложные доходы',
    step4_sub: 'Авто-реинвестирование',
    step4_i0: 'Расчёт события',
    step4_i1: 'Ликвидация прибыли',
    step4_i2: 'Расчёт сложного процента',
    step4_i3: 'Цикл реинвестирования',
    keyTitle: 'Основная цель',
    keyDesc: 'Цель PolyAi-Claw — непрерывно выявлять ценовые неэффективности на рынке и исполнять системный арбитраж.',
    keyHighlight: 'непрерывно выявлять ценовые неэффективности и исполнять системный арбитраж',
  },
  profitMechanism: {
    badge: 'Основной механизм прибыли',
    title1: 'Три механизма прибыли',
    title2: 'PolyAi-Claw',
    desc: 'Стабильная система вероятностного арбитража через обнаружение EV-преимущества, миллисекундное исполнение и трёхуровневое управление капиталом',
    m1_title: 'Обнаружение EV-преимущества',
    m1_sub: 'Обнаружение вероятностного преимущества',
    m1_desc: 'Основная логика: Рыночная цена ≠ Истинная вероятность. Когда ИИ обнаруживает отклонение, система автоматически входит в зону EV-преимущества.',
    m1_marketImplied: 'Подразумеваемая вероятность рынка',
    m1_aiTrue: 'Истинная вероятность ИИ',
    m1_probDiff: 'Вероятностное преимущество',
    m1_note: 'Тот же принцип, что и опционный арбитраж в квантовых фондах',
    m2_title: 'Миллисекундное авто-исполнение',
    m2_sub: 'Миллисекундное исполнение',
    m2_desc: 'Полностью автоматизированная система исполнения гарантирует, что ни одна арбитражная возможность не будет упущена.',
    m2_i0_title: 'Скорость исполнения в миллисекундах',
    m2_i0_sub: 'Среднее <200мс',
    m2_i1_title: 'Полная прозрачность на блокчейне',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'Ноль человеческого вмешательства',
    m2_i2_sub: 'Авто-расчёт смарт-контрактом',
    m2_network_label: 'Сеть исполнения',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'Трёхуровневое управление капиталом',
    m3_sub: 'Трёхуровневый контроль рисков',
    m3_desc: 'Трёхуровневая структура капитала обеспечивает долгосрочную стабильную работу системы.',
    m3_i0_title: 'Пул стабильного дохода',
    m3_i0_desc: 'Высокодостоверный вероятностный арбитраж, минимальный риск',
    m3_i1_title: 'Пул арбитража волатильности',
    m3_i1_desc: 'Захватывает рыночную волатильность, высокая эластичность доходности',
    m3_i2_title: 'Пул хеджирования',
    m3_i2_desc: 'Хеджирование событий с низкой корреляцией, снижение системного риска',
    m3_risk: 'Экспозиция по одному событию < 5%',
    formula_title: 'Формула вероятностного арбитража',
    formula_marketPrice: 'Рыночная цена',
    formula_aiTrue: 'Истинная вероятность ИИ',
    formula_trigger: 'Триггер позиции',
    formula_arbitrage: 'Арбитраж',
    formula_hiddenPct: 'Подразумевается 60%',
    formula_evEdge: 'EV-преимущество +12%',
    formula_autoExec: 'Авто-исполнение',
  },
  fundManagement: {
    riskTitle: 'Основные принципы контроля рисков',
    riskDesc: 'Система устанавливает максимальную экспозицию по одному событию < 5%, гарантируя, что даже крайние результаты не окажут существенного влияния на общий фонд.',
    riskHighlight: 'максимальная экспозиция по одному событию < 5%',
    stat_maxSingle: 'Макс. разовая инвестиция',
    stat_maxSingleVal: '5%',
    stat_diversify: 'Диверсификация капитала',
    stat_diversifyVal: '20+ событий',
    stat_stopLoss: 'Механизм стоп-лосса',
    stat_stopLossVal: 'Авто-триггер',
    vizTitle: 'Визуализация контроля рисков',
    viz_exposure: 'Контроль экспозиции',
    viz_diversify: 'Диверсификация капитала',
    viz_correlation: 'Корреляция событий',
    viz_stability: 'Стабильность стратегии',
  },
  techAdvantage: {
    badge: 'Ключевые преимущества',
    title1: 'Почему PolyAi-Claw',
    title2: 'превосходит традиционные рынки предсказаний?',
    dim_decision: 'Основа решений',
    dim_monitor: 'Частота мониторинга',
    dim_execute: 'Метод исполнения',
    dim_model: 'Когнитивная модель',
    dim_risk: 'Контроль рисков',
    human_decision: 'На эмоциях',
    human_monitor: 'Низкочастотный',
    human_execute: 'Ручные ордера',
    human_model: 'Субъективный',
    human_risk: 'На опыте',
    ai_decision: 'На данных',
    ai_monitor: 'Высокочастотный',
    ai_execute: 'Авто-исполнение',
    ai_model: 'Вероятностная модель',
    ai_risk: 'Алгоритмическое управление',
    humanPredict: 'Прогноз человека',
    adv1_title: 'Данные vs Эмоции',
    adv1_desc: 'PolyAi-Claw строит модели на основе мультиисточниковых данных, используя байесовское обновление вероятностей для расчёта истинных вероятностей в реальном времени.',
    adv1_label: 'Источники данных',
    adv2_title: 'Высокая частота vs Низкая частота',
    adv2_desc: 'Система непрерывно мониторит рыночные изменения 24/7, выявляя возможности отклонения вероятностей в реальном времени.',
    adv2_label: 'Частота мониторинга',
    adv3_title: 'Авто-исполнение vs Ручные ордера',
    adv3_desc: 'Миллисекундное авто-исполнение через смарт-контракты в сети Polygon — без задержек и ошибок.',
    adv3_label: 'Скорость исполнения',
    adv4_title: 'Алгоритм vs Опыт',
    adv4_desc: 'Трёхуровневая система управления капиталом с экспозицией по одному событию строго менее 5%.',
    adv4_label: 'Контроль рисков',
    conclusion_title: 'От рынка предсказаний к Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'Это превращает PolyWin из простого рынка предсказаний в',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'Система квантовых предсказаний Poly Ai Claw',
  },
  productNarrative: {
    badge: 'Позиционирование продукта',
    title: 'Истинная идентичность PolyWin',
    desc: 'PolyWin — это не просто рынок предсказаний, это интегрированная система, объединяющая ИИ, рынки предсказаний, OpenClaw и квантовую торговлю.',
    item0_title: 'Система вероятностного арбитража',
    item0_sub: 'Непрерывно захватывает рыночные неэффективности',
    item1_title: 'Дисциплинированная модель исполнения',
    item1_sub: 'Автоматизировано, ноль эмоционального вмешательства',
    item2_title: 'Движок ИИ-управления рисками',
    item2_sub: 'Интеллектуальный контроль рисков для безопасности',
    visual_title: 'Три визуальных выражения',
    vis0_title: '① График отклонения кривой вероятностей',
    vis0_desc: 'Показывает кривую вероятностей ИИ против кривой рыночного ценообразования',
    vis0_ai: 'Вероятность ИИ',
    vis0_market: 'Рыночная цена',
    vis0_diff: 'Разница вероятностей',
    vis1_title: '② Радарная диаграмма контроля рисков',
    vis1_desc: 'Отображает экспозицию риска, диверсификацию капитала, корреляцию событий и стабильность стратегии',
    vis1_exposure: 'Экспозиция риска',
    vis1_diversify: 'Распределение капитала',
    vis1_safe: 'Безопасная зона',
    vis1_safeVal: 'Достигнута',
    vis2_title: '③ Диаграмма потока авто-торговли ИИ',
    vis2_desc: 'Полный цикл: Данные → ИИ → Исполнение → Расчёт → Компаундинг',
    vis2_exec: 'Скорость исполнения',
    vis2_execVal: 'Миллисекунды',
    vis2_auto: 'Степень автоматизации',
    vis2_compound: 'Цикл компаундинга',
    vis2_compoundVal: 'Непрерывный',
    core_title: 'Ключевое ценностное предложение',
    core_desc: 'Через автоматизированное вероятностное ценообразование и временной компаундинг PolyAi-Claw непрерывно захватывает ценовые отклонения.',
    core_highlight: 'автоматизированное вероятностное ценообразование и временной компаундинг',
    core_item0: 'Автоматизированное вероятностное ценообразование',
    core_item1: 'Механизм временного компаундинга',
    core_item2: 'Гарантия контроля рисков',
    core_item3: 'Непрерывный захват отклонений',
  },
  profitFlywheel: {
    badge: 'Маховик финансового роста на базе ИИ',
    title1: 'PolyWin AI',
    title2: 'Модель маховика прибыли',
    desc: 'Рост PolyWin основан не на прибыли от одной сделки — он опирается на управляемую ИИ систему непрерывного компаундинга',
    descHighlight: 'управляемая ИИ система непрерывного компаундинга',
    aiCore: 'Движок вероятностей ИИ',
    step1_title: 'Глобальный ввод данных',
    step1_sub: 'Глобальные данные',
    step1_desc: 'ИИ непрерывно мониторит новостные события, политические изменения, макроэкономические данные, настроения в соцсетях и стаканы заявок рынков предсказаний',
    step1_tech: '50+ источников данных',
    step1_techDetail: 'Мультиисточниковое слияние в реальном времени',
    step2_title: 'ИИ-моделирование вероятностей',
    step2_sub: 'Вероятностное моделирование',
    step2_desc: 'Использует байесовские вероятностные модели для расчёта истинных вероятностей',
    step2_tech: 'Байесовская модель',
    step2_techDetail: 'Динамическое обновление вероятностей в реальном времени',
    step3_title: 'Обнаружение отклонения вероятностей',
    step3_sub: 'Вероятностное преимущество',
    step3_desc: 'Когда истинная вероятность ИИ > подразумеваемой вероятности рынка, идентифицируется как EV-позитивная возможность',
    step3_tech: 'Отклонение EV >5%',
    step3_techDetail: 'Авто-обнаружение положительного EV',
    step4_title: 'Авто-исполнение торговли',
    step4_sub: 'Алгоритмическое исполнение',
    step4_desc: 'Система автоматически завершает построение позиции, хеджирование и исполнение ордеров в сети Polygon',
    step4_tech: 'Смарт-контракт',
    step4_techDetail: '<200мс миллисекундное исполнение',
    step5_title: 'Прибыль с рынка предсказаний',
    step5_sub: 'Рыночная прибыль',
    step5_desc: 'Когда исход события подтверждён или рыночная вероятность возвращается, система получает арбитражную прибыль',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'Авто-расчёт на блокчейне',
    step6_title: 'Возврат капитала',
    step6_sub: 'Рециркуляция капитала',
    step6_desc: 'Система автоматически возвращает прибыльный капитал в фонд',
    step6_tech: 'Расчёт в USDC',
    step6_techDetail: 'Стейблкоин без валютных потерь',
    step7_title: 'Компаундный рост',
    step7_sub: 'Компаундный капитал',
    step7_desc: 'По мере роста фонда ИИ может участвовать в более крупных рынках и большем количестве арбитражных возможностей',
    step7_tech: 'Авто-компаундинг',
    step7_techDetail: 'Цикл авто-реинвестирования прибыли',
    step8_title: 'Более крупный масштаб капитала',
    step8_sub: 'Более крупный пул ликвидности',
    step8_desc: 'Более крупный капитал означает более высокую торговую мощность и более стабильную доходность',
    step8_tech: 'Расширение ликвидности',
    step8_techDetail: 'Преимущество масштаба компаундируется',
    sum0_label: 'Уровень данных',
    sum0_tech: '50+ мультиисточниковых потоков',
    sum0_detail: 'Байесовское моделирование в реальном времени',
    sum1_label: 'Уровень исполнения',
    sum1_tech: 'Автоматизация смарт-контракта',
    sum1_detail: 'Расчёт на блокчейне Polygon PoS',
    sum2_label: 'Уровень расчётов',
    sum2_tech: 'USDC стейблкоин',
    sum2_detail: 'Расчёт без валютных потерь',
    sum3_label: 'Уровень компаундинга',
    sum3_tech: 'Авто-реинвестирование',
    sum3_detail: 'Положительный цикл расширения масштаба',
    key0_title: 'Самоусиливающийся цикл',
    key0_desc: 'Каждая прибыль усиливает возможности системы, формируя положительную обратную связь для экспоненциального роста',
    key1_title: 'Рост на базе ИИ',
    key1_desc: 'Рост не зависит от рефералов — он опирается на собственные возможности вероятностного арбитража ИИ',
    key2_title: 'Система непрерывного компаундинга',
    key2_desc: 'Через автоматизированный возврат прибыли и реинвестирование фонд непрерывно расширяется',
    formula_title: 'Формула роста маховика',
    f0_label: 'ИИ-данные',
    f1_label: 'Вероятностный арбитраж',
    f2_label: 'Прибыль',
    f3_label: 'Компаундинг',
    f4_label: 'Больше капитала',
    f5_label: 'Больше арбитража',
    connected: 'Подключено · В прямом эфире',
  },
  sysArch: {
    badge: 'Официальная архитектура',
    title1: 'PolyAi-Claw ИИ',
    title2: 'Архитектура системы',
    desc: 'Полная система ИИ-принятия решений от сбора данных до авто-расчёта с использованием моделей контроля рисков уровня квантового фонда',
    coreBadge: 'Основной мозг ИИ',
    feat0_title: 'Полная структура ИИ-системы',
    feat0_desc: 'Не просто стратегия — полная система ИИ-принятия решений, охватывающая весь поток от сбора данных до авто-исполнения',
    feat1_title: 'Контроль рисков уровня квантового фонда',
    feat1_desc: 'Профессиональные модели контроля рисков квантового фонда, включая контроль экспозиции, корреляционное хеджирование и динамическое распределение капитала',
    feat2_title: 'Масштабируемая архитектура',
    feat2_desc: 'Расширяемая в будущем на несколько рынков, сетей и стратегий',
    dataflow_title: 'Поток данных',
  },
  tradingExample: {
    badge: 'Живой пример сделки',
    title1: 'PolyAi-Claw BTC',
    title2: '5-минутная стратегия арбитража',
    desc: 'Система делает только три вещи: Обнаружить аномальную волатильность → Оценка вероятности за последние 60 секунд → Торговля в безопасной зоне',
    s1_title: 'Рыночные данные BTC',
    s1_sub: 'Мониторинг рынка в реальном времени',
    s1_notice: 'Образцовые данные для условий триггера стратегии',
    s1_price: 'Текущая цена',
    s1_eg: 'Пример',
    s1_priceVol: 'Волатильность цены',
    s1_vol: 'Объём',
    s1_depth: 'Глубина стакана',
    s1_trigger: 'Триггер: Волатильность ≥ 100 USD',
    s1_met: 'Выполнено',
    s2_title: 'Движок PolyAi-Claw',
    s2_sub: 'Расчёт вероятностей ИИ',
    s2_marketImplied: 'Подразумеваемая вероятность рынка',
    s2_aiTrue: 'Истинная вероятность ИИ',
    s2_yes: 'ДА',
    s2_probDiff: 'Вероятностное преимущество',
    s2_safe: 'Вход в безопасную торговую зону',
    s3_title: 'Авто-торговля + Прибыль',
    s3_sub: 'Авто-исполнение и доходность',
    s3_exec: 'Исполнение торговли',
    s3_buyYes: 'Купить ДА',
    s3_buyPrice: 'Цена входа',
    s3_settlement: 'Расчёт рынка предсказаний',
    s3_correct: 'Правильный прогноз',
    s3_profit: 'Доход за сделку',
    s3_avg: 'Средняя доходность',
    s3_recycle: 'Доходы возвращаются в пул',
    chart_title: 'ИИ-вероятность vs Отклонение рыночной вероятности',
    chart_sub: 'Отслеживание в реальном времени отклонения движка Poly Ai Claw от рыночного ценообразования',
    chart_live: 'Живой анализ',
    chart_curDev: 'Текущее отклонение',
    chart_signal: 'Арбитражный сигнал',
    chart_signalVal: 'Сработал',
    chart_winRate: 'Прогноз процента выигрышей',
    chart_bottom_implied: 'Подразумеваемая вероятность рынка',
    chart_bottom_dev: 'Зона отклонения вероятностей',
    chart_bottom_dev_sub: 'Арбитражная возможность сработала',
    chart_bottom_ai: 'Истинная вероятность ИИ',
    chart_bottom_ai_sub: 'Вывод модели Poly Ai Claw',
    chart_bottom_implied_sub: 'На основе рыночной цены',
    chart_marketProb: 'Подразумеваемая вероятность рынка',
    chart_aiProb: 'Истинная вероятность ИИ',
    chart_deviationArea: 'Зона арбитражного отклонения',
    maxDeviation: 'Макс. отклонение',
    deviation: 'Отклонение',
    flow_title: 'Полный поток стратегии',
    flow0_title: 'Мониторинг данных BTC',
    flow0_desc: 'Цена/объём в реальном времени',
    flow1_title: 'Обнаружение волатильности',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'Временной фильтр',
    flow2_desc: 'Последние 60 секунд',
    flow3_title: 'Оценка процента выигрышей',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'Авто-исполнение',
    flow4_desc: 'Купить ДА/НЕТ',
    flow5_title: 'Рыночный расчёт',
    flow5_desc: '1 USDC',
    flow6_title: 'Компаундные доходы',
    flow6_desc: '3%-10%',
    risk0_title: 'Структура контроля рисков',
    risk0_i0: 'Лимит капитала на событие < 5%',
    risk0_i1: 'Диверсификация по нескольким событиям',
    risk0_i2: 'Динамический стоп-лосс ИИ',
    risk1_title: 'Стратегия тайминга',
    risk1_i0: 'Исполнение в последние 60 секунд',
    risk1_i1: 'Избегание эмоциональной торговли',
    risk1_i2: 'Более полная информация',
    risk2_title: 'Историческая эффективность',
    risk2_i0: 'Исторический процент выигрышей 80%-90%',
    risk2_i1: 'Средняя доходность 3%-10%',
    risk2_i2: 'Стабильная арбитражная модель',
  },
  crossPlatform: {
    badge: 'Кросс-платформенный арбитраж предсказаний',
    title1: 'PolyAi CLaw',
    title2: 'Логика кросс-платформенного арбитража рынков предсказаний',
    desc: 'Соединяет Polymarket (Web3) и Kalshi (Фиат) — захватывает ценовые отклонения с интеллектуальным сопоставлением и ультрабыстрым исполнением',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'Фиат',
    claw: 'CLaw',
    matched: '✓ Сопоставлено',
    matching: 'Сопоставление...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ Точность',
    sec1_title: 'Интеллектуальное сопоставление рынков',
    sec1_desc: 'События на обеих платформах автоматически привязываются семантическим ИИ, выявляя кросс-платформенные спреды за миллисекунды',
    sec2_badge: '02',
    sec2_ms: 'Миллисекундное исполнение',
    sec2_title: 'Единая интеграция и ультрабыстрая торговля',
    sec2_desc: 'Унифицированный API/SDK подключает несколько платформ с синхронным размещением ордеров за миллисекунды',
    connected: 'Подключено · В прямом эфире',
    latency: 'Задержка ордера',
    dailyEvents: 'Ежедневно сопоставленных событий',
    successRate: 'Успешность исполнения',
    platforms: 'Синхронизированных платформ',
    sec3_badge: '03',
    sec3_analytics: 'Живая аналитика',
    sec3_title: 'Визуализация арбитражных данных',
    sec3_desc: 'Ценовое отклонение в реальном времени, арбитражная доходность и тенденции роста — динамически представляет кросс-платформенную арбитражную ценность',
    priceDeviation: 'Распределение ценовых отклонений',
    volumeTitle: 'Ежемесячный объём (тыс. USDC)',
    h1Volume: 'Накопленный объём H1 (USDC)',
    arbIndicators: 'Метрики арбитражного преимущества',
    arbSuccess: 'Успешность спред-арбитража',
    semanticAccuracy: 'Точность семантического сопоставления',
    liquidity: 'Кросс-платформенная ликвидность',
    hedgeCoverage: 'Коэффициент покрытия хеджирования',
  },
  mathAlgo: {
    badge: 'Точные продвинутые математические алгоритмы',
    title1: 'Арбитраж на Polymarket — это не',
    title2: 'простая математическая задача',
    quote: 'Пока вы вручную делаете это сложение, квантовая система делает совершенно другое.',
    quoteHighlight1: 'вручную делаете это сложение',
    quoteHighlight2: 'совершенно другое',
    ch0_title: 'Что такое арбитраж? Почему на Polymarket его так много?',
    ch0_tag: 'Рыночная неэффективность',
    ch1_title: 'Кросс-рыночный арбитраж: логические зависимости',
    ch1_tag: 'Комбинаторная математика',
    ch2_title: 'Проекция Брегмана: вычисление оптимального размера арбитража',
    ch2_tag: 'Выпуклая оптимизация',
    pipeline_title: 'Система арбитража Polymarket — полная архитектура',
    layer0: 'Уровень 1: Сбор данных',
    layer1: 'Уровень 2: Обнаружение зависимостей',
    layer2: 'Уровень 3: Трёхуровневый движок оптимизации',
    layer3: 'Уровень 4: Исполнение и управление позициями',
    annualProfit: 'Годовая общая извлечённая прибыль: $39 688 585',
    venn_title: 'Логическая зависимость: P(Выиграть на 5%) ⊆ P(Выиграть)',
    contradiction: 'Противоречие! P(подмножество) > P(родитель) → Арбитражный сигнал',
    contradiction_sub: '0,55 > 0,48 → Логическое противоречие → Арбитражная возможность',
    combinations: 'Комбинации рынков',
    brutal: 'Перебор невозможен',
    integerConstraints: 'Ограничения целочисленного программирования',
    replaces: 'Заменяет 16 384 перечисления',
    bregman_title: 'KL-дивергенция vs Евклидово расстояние',
    coreData: 'Основные данные',
    pipeline4: '4-уровневый конвейер системы',
    annualReturn: 'Годовая прибыль ≈ $39,7 млн',
    whyNotEnough_title: 'Почему "сумма цен = $1" недостаточно?',
    singleMarket: 'Один рынок — всё нормально',
    crossMarket: 'Кросс-рынок — экспоненциальный взрыв',
  },
  mathProfit: {
    ch3_title: 'Алгоритм Франка-Вульфа: приближение к ответу шаг за шагом',
    ch3_tag: 'Итерационный алгоритм',
    ch3_chapter: 'Глава 04',
    execTitle: 'Риск неатомарного исполнения',
    profitStructure: 'Структура прибыли (апр. 2024 – апр. 2025)',
    totalProfit: 'Итого: $39 688 585',
    top10: 'ТОП 10 составил 20,5%',
    kellyFormula: 'Формула позиции модифицированного Келли',
    preTrade: '4 предторговых контрольных точки',
    gate0: 'Достаточная ликвидность?',
    gate1: 'Допустимое проскальзывание?',
    gate2: 'Всё ещё прибыльно после проскальзывания?',
    gate3: 'Прибыль > $0,05 → Исполнить',
  },
  safuFund: {
    badge: 'Гарантия безопасности активов',
    title: 'Polywin SAFU Фонд',
    titleHighlight: 'SAFU Фонд',
    desc: 'Заблокированные резервы на блокчейне, прозрачные и верифицируемые в реальном времени — ваши активы, наше обязательство',
    reserveLabel: 'Общий резерв · USDC · Основная сеть Ethereum',
    verified: 'Верифицировано на блокчейне',
    mainDesc: 'Команда Polywin заблокировала 10 миллионов USDC в качестве резервного фонда безопасности SAFU в основной сети Ethereum, предназначенного для защиты активов пользователей в случае взлома.',
    mainDescHighlight: '10 миллионов USDC',
    contractLabel: 'Адрес контракта',
    etherscanBtn: 'Проверить на Etherscan',
    stat0_label: 'Размер резерва',
    stat0_sub: 'USDC',
    stat1_label: 'Коэффициент блокировки на блокчейне',
    stat1_sub: 'На блокчейне',
    stat2_label: 'Верифицируемый',
    stat2_sub: 'В реальном времени',
    stat3_label: 'Исторические выплаты',
    stat3_val: '$0',
    stat3_sub: 'Нулевой рекорд потерь',
    f0_title: 'Заблокировано на блокчейне',
    f0_desc: '100% средств заблокированы в смарт-контрактах основной сети Ethereum — команда не может снять или перевести их произвольно',
    f1_title: 'Полностью прозрачный',
    f1_desc: 'Любой может просматривать баланс фонда и все исторические транзакции в реальном времени через Etherscan',
    f2_title: 'Быстрая компенсация',
    f2_desc: 'Процесс компенсации инициируется в течение 72 часов после подтверждённого инцидента безопасности',
    f3_title: 'Независимый аудит',
    f3_desc: 'Сторонние агентства по безопасности регулярно проверяют код контракта для обеспечения подлинности резервных средств',
  },
  cta: {
    badge: 'Начните прямо сейчас',
    title1: 'Начните использовать',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'Не требуется опыт программирования — настройте стратегии ИИ за 3 минуты',
    btn: 'Запустить AI-Claw',
    trust0: 'Официальный партнёр Polygon',
    trust1: 'Сертифицировано аудиторским агентством',
    trust2: '10 000+ активных пользователей',
    trust3: '$50M+ совокупного объёма',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'Продукт',
    resources: 'Ресурсы',
    social: 'Социальные сети',
    link0: 'Алгоритм Poly AI-Claw',
    link1: 'Система контроля рисков',
    link2: 'API данных',
    link3: 'Документация для разработчиков',
    res0: 'Руководство',
    res1: 'Примеры стратегий',
    res2: 'Whitepaper',
    res3: 'Форум сообщества',
    copyright: '© 2026 PolyWin. Все права защищены.',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
  },
};
